import HomeVideos from './HomeVideos';

const Home = () => {
  return <HomeVideos />;
};

export default Home;
